module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && _vm.advisory.body) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "advisory",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content pad-15 advisory-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.advisory.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.advisory.body)
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row pad-5"
  }, [_c('div', {
    staticClass: "col-xs-6 inline-el"
  }, [_c('span', {
    staticClass: "form-label"
  }, [_vm._v("Do not show this message again?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doNotShowAgain),
      expression: "doNotShowAgain"
    }],
    attrs: {
      "id": "add-st",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.doNotShowAgain) ? _vm._i(_vm.doNotShowAgain, null) > -1 : (_vm.doNotShowAgain)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.doNotShowAgain,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.doNotShowAgain = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.doNotShowAgain = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.doNotShowAgain = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-warning",
    attrs: {
      "for": "add-st"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default sq pull-right",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("\n              Close\n            ")])])])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4fcb376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Advisory.vue
// module id = 2289
// module chunks = 1